export const CHECKOUT_URL = 'https://soldadura-fr.impultienda.ar/checkout/'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/5EbmpGGZ2kCqHrQaApSHQE/SOLDADURA-FR.png'

export const stats = [
  { value: '+300', label: 'Solutions pratiques' },
  { value: '+1 200', label: 'Soudeurs' },
  { value: '6', label: 'Manuels maîtres' },
  { value: '99 %', label: 'Le recommandent' },
]

export const painPoints = [
  'Vous perdez du matériau à cause de réglages incorrects.',
  'Vous devinez l’ampérage chaque fois que l’épaisseur change.',
  'Vos cordons de soudure sont différents à chaque essai.',
  'Vous ne savez pas si votre soudure résistera réellement à la charge.',
  'Chaque projet commence par des doutes et de l’improvisation.',
]

export const gainPoints = [
  'Vous saurez exactement quel réglage utiliser avant de commencer.',
  'Vous obtiendrez des cordons plus propres, solides et réguliers.',
  'Vous réduirez le gaspillage d’électrodes et de matériau.',
  'Vous corrigerez les erreurs plus rapidement.',
  'Vous souderez avec l’assurance de quelqu’un qui sait exactement ce qu’il fait.',
]

export const forYouPoints = [
  'Vous possédez un poste à souder, mais vous n’avez jamais vraiment appris à bien l’utiliser.',
  'Vous apprenez sur YouTube, mais chaque vidéo vous donne des conseils différents.',
  'Vous doutez toujours avant de régler votre machine.',
  'Vous gaspillez des électrodes et du matériau à cause d’erreurs évitables.',
  'Vous voulez réaliser vos propres projets avec confiance.',
  'Vous voulez arrêter de dépendre des autres pour vos réparations.',
  'Vous voulez obtenir des résultats qui paraissent réellement professionnels.',
]

export const manuals = [
  {
    number: '1',
    title: 'Méthode Zéro Erreur™',
    description:
      'Ce qu’il faut faire avant de souder pour éviter les erreurs les plus fréquentes dès le premier jour.',
  },
  {
    number: '2',
    title: 'Contrôle Total de l’Arc™',
    description:
      'Maîtrisez la technique pour obtenir des cordons propres, réguliers et résistants.',
  },
  {
    number: '3',
    title: 'Code Maître de Configuration™',
    description:
      'Réglez correctement votre poste à souder en quelques secondes sans plus jamais devoir deviner.',
  },
  {
    number: '4',
    title: 'Soudures Sans Limites™',
    description: 'Apprenez à souder en toute sécurité dans n’importe quelle position.',
  },
  {
    number: '5',
    title: 'Laboratoire du Soudeur™',
    description:
      'Détectez et corrigez les défauts de soudure grâce à une simple inspection visuelle.',
  },
  {
    number: '6',
    title: 'Finition Professionnelle™',
    description: 'Obtenez des finitions qui inspirent qualité et professionnalisme.',
  },
]

export const instantAccess = [
  'Les 6 Manuels Maîtres au format numérique.',
  'Plus de 300 solutions pratiques étape par étape.',
  'Des tableaux de configuration prêts à consulter.',
  'Des guides visuels pour diagnostiquer les erreurs.',
  'Des check-lists de référence rapide.',
  'Un accès depuis votre téléphone, tablette ou ordinateur.',
]

export const bonuses = [
  {
    tag: 'BONUS #1',
    title: 'Centre des Coûts du Soudeur™',
    description: 'Calculez correctement combien facturer pour chaque travail.',
    value: '47 €',
    image:
      'https://cdn.magicpatterns.com/uploads/6SYtq9GpA6YzaBAAs8YiFm/BONUS_1_SOLDADURA-FR.png',
  },
  {
    tag: 'BONUS #2',
    title: 'Finition Premium™',
    description:
      'Donnez à chaque projet l’apparence d’une réalisation issue d’un atelier professionnel.',
    value: '37 €',
    image:
      'https://cdn.magicpatterns.com/uploads/a89hX6s4N96fM3i6YaGjFi/BONUS_2_SOLDADURA-FR.png',
  },
  {
    tag: 'BONUS #3',
    title: 'Bibliothèque des Cordons Parfaits™',
    description: 'Comparez, identifiez et corrigez n’importe quel défaut de soudure.',
    value: '67 €',
    image:
      'https://cdn.magicpatterns.com/uploads/8jbX4VkxnPUCT7gMioh6hr/BONUS_3_SOLDADURA-FR.png',
  },
  {
    tag: 'BONUS #4',
    title: 'Kit Maître pour Trouver des Clients™',
    description:
      'Des modèles et stratégies pour obtenir vos premiers clients et vos premiers travaux.',
    value: '57 €',
    image:
      'https://cdn.magicpatterns.com/uploads/mfVmcBfjYutdio3UrrH9t5/BONUS_4_SOLDADURA-FR.png',
  },
  {
    tag: 'BONUS #5',
    title: 'Planificateur de Productivité pour Soudeurs™',
    description:
      'Organisez vos projets, gérez votre temps et augmentez votre productivité : moins de désorganisation, plus de travaux.',
    value: '37 €',
    image:
      'https://cdn.magicpatterns.com/uploads/s5EBCfCAcZKYimUJe5mpE7/BONUS_5_SOLDADURA-FR.png',
  },
]

export const testimonials = [
  {
    name: 'Carlos Medina',
    role: 'Métallier · Córdoba, Argentine',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/11c8685b-0751-40c9-81b9-f0ca6d68a53e.jpg',
    quote:
      'J’avais mon poste à souder depuis deux ans et je devinais toujours l’ampérage. Avec les tableaux du Système Maître, je règle tout en quelques secondes et mes cordons sont maintenant beaucoup plus réguliers. J’ai arrêté de gaspiller mes électrodes.',
  },
  {
    name: 'Nahuel Ríos',
    role: 'Passionné · Rosario, Argentine',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/3fc1b680-f093-4119-8ea3-0af5f6b9adf8.jpg',
    quote:
      'J’apprenais sur YouTube, mais chaque vidéo disait quelque chose de différent. Ici, tout est organisé étape par étape. J’ai déjà fabriqué un barbecue et une grille pour ma maison sans devoir dépendre de quelqu’un d’autre.',
  },
  {
    name: 'Diego Fernández',
    role: 'Soudeur · Mendoza, Argentine',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/6b78ef5c-d36e-4236-9c92-b7263628e403.jpg',
    quote:
      'Le manuel de diagnostic des erreurs est une véritable mine d’or. Maintenant, je regarde mon cordon et je sais immédiatement ce que je dois corriger. J’ai commencé à facturer des travaux grâce au bonus sur les coûts et j’ai largement rentabilisé mon investissement.',
  },
]

export const faqs = [
  {
    question: 'Comment vais-je recevoir le Système Maître ?',
    answer:
      'Immédiatement après votre paiement, vous recevrez un e-mail avec votre accès aux 6 Manuels Maîtres et aux 5 Bonus Exclusifs au format numérique.',
  },
  {
    question: 'Est-ce adapté si je n’ai jamais soudé ?',
    answer:
      'Oui. Le système est conçu pour vous aider à comprendre les bases, éviter les erreurs les plus fréquentes et progresser étape par étape.',
  },
  {
    question: 'Est-ce aussi utile si j’ai déjà de l’expérience ?',
    answer:
      'Oui. Les tableaux, guides de diagnostic, références pratiques et solutions rapides peuvent vous aider à gagner du temps et à obtenir des résultats plus réguliers.',
  },
  {
    question: 'Ai-je besoin d’Internet pour l’utiliser ?',
    answer:
      'Vous avez besoin d’Internet pour accéder et télécharger votre contenu. Une fois vos ressources téléchargées sur votre appareil, vous pouvez les consulter selon le format disponible.',
  },
  {
    question: 'Est-ce un paiement unique ?',
    answer: 'Oui. Vous effectuez un seul paiement de 19 €, sans abonnement mensuel.',
  },
  {
    question: 'Que se passe-t-il si le système ne me plaît pas ?',
    answer:
      'Vous êtes couvert par notre garantie de satisfaction de 7 jours. Si vous estimez que le produit ne correspond pas à vos attentes, contactez-nous pendant cette période.',
  },
]

export const purchaseNotifications = [
  { name: 'Miguel A.', country: 'Espagne' },
  { name: 'Lucas P.', country: 'Argentine' },
  { name: 'Javier R.', country: 'Mexique' },
  { name: 'Andrés G.', country: 'Colombie' },
  { name: 'Sebastián M.', country: 'Chili' },
  { name: 'Rodrigo V.', country: 'Pérou' },
  { name: 'Fernando L.', country: 'Uruguay' },
  { name: 'Diego C.', country: 'Équateur' },
  { name: 'Emilio S.', country: 'Paraguay' },
  { name: 'Iván T.', country: 'République dominicaine' },
  { name: 'Marcos D.', country: 'Costa Rica' },
  { name: 'Alejandro N.', country: 'Panama' },
]
